angular.module('unica_transfer.transfer_controllers')

.controller('TransferCreateController', function(
	$rootScope, $scope, $state,
	TransferCreateService
) {

	$scope.pageTitle = 'Aggiungi Transfer';

	$scope.resetTransferData();

	$scope.saveTransfer = function () {
		$scope.showLoader();

		TransferCreateService
			.create( $scope.transferData )
			.then(function(data) {
				$scope.hideLoader();

				if (!data.error) {
					$scope.showSuccessMsg('Transfer aggiunto con successo!', '');
					$state.go('app.hospitality.transfer_list');
				} else {
					$rootScope.manageError(data);
				}
			});
	};

});




